import { Fragment } from 'react'
import { ReactComponent as Guideline } from '@/svg/guildline.svg'
import { ReactComponent as Preparation } from '@/svg/preparation.svg'
import { ReactComponent as PDPADocument } from '@/svg/pdpa-document.svg'
import { ReactComponent as Awareness } from '@/svg/roles-awareness-training.svg'
import { ReactComponent as Policy } from '@/svg/policy-notice.svg'
import { ReactComponent as Assessment } from '@/svg/risk-assertment-tool.svg'

const items: WidgetContentInterface[] = [
  {
    symbol: <Guideline />,
    title: 'Guideline',
    content: (
      <Fragment>
        เอกสารแนะนำแนวทางในการปฏิบัติ
        <br />
        ตาม PDPA พร้อม Example Case
        <br />
        ที่สามารถประยุกต์ใช้ได้จริง
      </Fragment>
    ),
  },
  {
    symbol: <Preparation />,
    title: 'Preparation Tool',
    content: (
      <Fragment>
        คู่มือในการเตรียมปฏิบัติตาม PDPA
        <br />
        อย่างละเอียดทุกขั้นตอน พร้อมเช็คลิสต์
        <br />
        ให้สามารถทำตามได้ง่าย&nbsp;ๆ
      </Fragment>
    ),
  },
  {
    symbol: <PDPADocument />,
    title: 'PDPA Document',
    content: (
      <Fragment>
        เอกสารทางกฎหมายทั้งหมด
        <br />
        ที่จำเป็นต่อการปฏิบัติตามกับ
        <br />
        พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล
      </Fragment>
    ),
  },
  {
    symbol: <Awareness />,
    title: 'Roles, Awareness, Training',
    content: (
      <Fragment>
        คู่มือและสไลด์สำหรับให้องค์กร
        <br />
        ให้ความรู้พนักงานเกี่ยวกับหน้าที่
        <br />
        และความรับผิดชอบใน PDPA
      </Fragment>
    ),
  },
  {
    symbol: <Policy />,
    title: 'Policies and Notices',
    content: (
      <Fragment>
        คู่มือการจัดทำนโยบายและประกาศต่าง&nbsp;ๆ
        <br />
        ที่ธุรกิจต้องมี พร้อมอธิบายการนำไปใช้
        <br />
        และตัวอย่างทุกนโยบาย
      </Fragment>
    ),
  },
  {
    symbol: <Assessment />,
    title: 'Risk Assessment Tool',
    content: (
      <Fragment>
        แบบฟอร์มประเมินความเสี่ยง
        <br />
        การปฏิบัติที่ไม่สอดคล้องกับ
        <br />
        พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล
      </Fragment>
    ),
  },
]

export default {
  items,
}
